module.exports = __webpack_public_path__ + "img/file-generic.08906a56.svg";